// extracted by mini-css-extract-plugin
export default {"block":"trafficController_block__EvyJK","first_block":"trafficController_first_block__Ggo2h"};